import { useQuery } from "react-query";
import { createApiWithPath } from "../../client";
import { VoiceRequestsResponse } from "../../types/voice-requests";

export interface VoiceRequestFilters {
  status?: string;
  type?: string;
  token?: string;
  profileId?: string;
  q?: string;
}

export const useVoiceRequests = (filters: VoiceRequestFilters = {}) => {
  return useQuery<VoiceRequestsResponse>(
    ["voice-requests", filters],
    async () => {
      const response = await createApiWithPath("voice-requests").get("", {
        params: filters,
      });
      return response.data;
    },
  );
};
